/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DynamicTagsRequest,
  DynamicTagsResponse,
  Email,
  MapString,
  ResolveTemplatesRequest,
  ResolveTemplatesResponse,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "dynamic-tags";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns a list of dynamic tag references along with additional details for categorization
   *
   * @name GetAllDynamicTags
   * @request POST:/v1/tenant/{tenantId}/tags
   * @secure
   */
  getAllDynamicTags = (tenantId: string, data: DynamicTagsRequest, params: RequestParams = {}) =>
    this.request<
      DynamicTagsResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tags`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllDynamicTags */
  getAllDynamicTagsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/tags`);

  /**
   * @description Returns template substitution result
   *
   * @name ResolveTemplate
   * @request PUT:/v1/tenant/{tenantId}/resolve-template
   * @secure
   */
  resolveTemplate = (
    tenantId: string,
    data: ResolveTemplatesRequest,
    query?: {
      /** Set to 'true' to leave all unresolved tags untouched to make this template partially resolved. By default all unresolved tags are replaced with an empty string */
      partial?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ResolveTemplatesResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/resolve-template`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for resolveTemplate */
  resolveTemplatePathGetter = (
    tenantId: string,
    query?: {
      /** Set to 'true' to leave all unresolved tags untouched to make this template partially resolved. By default all unresolved tags are replaced with an empty string */
      partial?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/resolve-template`, query);
}
